import React from "react";
import styled from "styled-components";
import { textGradient } from "../GradientBox";
import { LandingPageTemplate } from "./LandingTemplate";

export const ActivityRejuvenatesLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      header={<Header />}
      illustration={
        <img
          height={326}
          style={{
            marginTop: "-20px",
            marginBottom: "-20px",
          }}
          src="/landing-pages/activity-rejuvenates.png"
        />
      }
      androidStoreListing={"ruch_odmladza"}
      appStorePpid={"ee8f416c-eed4-4dc9-bb71-e908b2407609"}
    />
  );
};

export default ActivityRejuvenatesLanding;

const Header: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ContentHeader>
        Obserwuj,
        <br />
        jak ruch Cię
        <br />
        odmładza
      </ContentHeader>
    </div>
  );
};

const ContentHeader = styled.h1`
  font-size: 32px;
  font-weight: bold;
  background: ${textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0px;
`;
